@if (repositories$ | async; as repositories) {
	<stages-dialog2 #dialog [classes]="[]" [dialogAriaLabel]="getDialogTitleKey() | translate">
		<stages-dialog-header>
			@if (repositories.length <= 1) {
				<div class="title">
					<i class="ico ico-database"></i>
					<span class="h3 shorten">{{ activeRepository.name }} ({{ activeRepository.repositoryType }})</span>
				</div>
			}
			@if (repositories.length > 1 && !isRepositorySelectionActive) {
				<a
					class="title clickable"
					(click)="showRepositories()"
					title="{{ 'management.files.browser.changeRepository' | translate }}"
				>
					<i class="ico ico-database"></i>
					<span class="h3 shorten">{{ activeRepository.name }} ({{ activeRepository.repositoryType }})</span>
				</a>
			}
			@if (isRepositorySelectionActive) {
				<a class="title clickable" (click)="showFileSelection()" title="{{ getSwitchToFileInputMessage() }}">
					<i class="ico ico-arrow-back"></i>
					<span class="h3">{{ getSwitchToFileInputMessage() }}</span>
				</a>
			}
		</stages-dialog-header>
		<span class="h1" translate="{{ getDialogTitleKey() }}"></span>
		@if (!isRepositorySelectionActive && activeRepository.error) {
			<div class="panel">
				<p class="error" translate="{{ activeRepository.error.titleKey }}"></p>
				<p>{{ activeRepository.error.message }}</p>
			</div>
		}
		@if (!isRepositorySelectionActive && activeRepository.contentBrowseable && !isInManualEntryMode()) {
			<div class="contentpadding">
				<div class="input-container auto-complete">
					<input id="input-filepath" type="search" class="search" [readonly]="true" [(ngModel)]="activePath" />
					<div class="info">
						<div class="errors">
							@if (isPathTooLong()) {
								<div class="error" role="alert" translate="management.files.browser.pathTooLong"></div>
							}
						</div>
					</div>
				</div>
			</div>
		}
		@if (isInManualEntryMode()) {
			<div class="form auto-complete">
				<form #form="ngForm">
					<div class="input-container">
						<label for="input-filepath" class="input-label" translate="management.files.browser.path.label"></label>
						<input
							#pathControl="ngModel"
							id="input-filepath"
							type="search"
							name="path"
							class="search"
							[(ngModel)]="activePath"
							[stagesMaxLength]="255"
							required
							stagesAutofocus
						/>
					</div>
					<div class="info">
						@if (form.submitted || pathControl.dirty || pathControl.touched) {
							<div class="errors">
								@if (pathControl?.errors?.max) {
									<div
										class="error"
										role="alert"
										translate="input.maxLength"
										[translateParams]="{ length: '255' }"
									></div>
								}
								@if (pathControl?.errors?.required) {
									<div class="error" role="alert" translate="input.required"></div>
								}
							</div>
						}
						<div class="maxlength"></div>
					</div>
				</form>
			</div>
		}
		@if (!isRepositorySelectionActive && activeRepository.contentBrowseable) {
			<div class="button-line contentpadding" [ngClass]="{ hidden: navigationButtonsHidden }">
				<button
					class="button clickable"
					(click)="handleUpClicked()"
					title="{{ 'management.files.browser.navigateUp' | translate }}"
				>
					<i class="ico ico-arrow-up"></i>
				</button>
				<button
					class="button clickable"
					(click)="handleRootClicked()"
					title="{{ 'management.files.browser.navigateToRoot' | translate }}"
				>
					<i class="ico ico-root-folder"></i>
				</button>
			</div>
		}
		@if (!isRepositorySelectionActive) {
			<article class="content">
				@if (activeRepository?.contentBrowseable && activeItem?.children) {
					<nav>
						<stages-table-viewer
							[items]="activeItem.children"
							[columns]="tableColumns"
							[rowProvider]="getTableRow"
							[cellProvider]="getTableCell"
							[selection]="selectionInThisFolder"
							(selectionChanged)="handleSelectionUpdate()"
							(itemClicked)="handleItemClicked($event)"
							(sortOrderChanged)="handleSortOrderChanged($event)"
							columnNamePrefix="management.files.browser.column."
							translateNone="management.files.browser.emptyFolder"
						>
						</stages-table-viewer>
					</nav>
				}
			</article>
		}
		@if (isRepositorySelectionActive) {
			<article class="content">
				<nav>
					<ul class="list">
						@for (repository of repositories; track trackByRepositoryId($index, repository)) {
							<li class="list-item">
								<a class="label clickable" (click)="handleRepositorySelected(repository)">
									<div class="text">
										<span class="h3">{{ repository.name }}</span>
										<span class="h6">{{ repository.repositoryType }}</span>
									</div>
								</a>
							</li>
						}
					</ul>
				</nav>
			</article>
		}
		@if (needsSelectionSizeDisplay()) {
			<p class="contentpadding">
				<span>{{ getSelectionSizeMessage() }}</span>
			</p>
		}
		@if (needsSaveAndCancelButtons()) {
			<footer>
				<div class="buttons">
					<button class="button sm cancel" (click)="dialog.close()" translate="cancel"></button>
					<button class="button sm save" [disabled]="!canSave()" (click)="save()">
						@if (!saveInProgress) {
							<span translate="files.start.cm.button"></span>
						}
						@if (saveInProgress) {
							<stages-spin size="s"></stages-spin>
						}
					</button>
				</div>
			</footer>
		}
	</stages-dialog2>
}
